import { DownloadOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { FC, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { useGetSendProductionExport } from "hooks/useOrders";
import { numberFormat } from "utils/nuberFormat";
import { useAppSelector } from "store";

interface ExportToProductionProps {}
const ExportToProduction:FC<ExportToProductionProps> = ({  }) => {
  const [loading, setLoading] = useState(false);
  const { data: dataProduction } = useGetSendProductionExport();
  const usrName = useAppSelector((state) => state.auth.profile?.user?.name);
 
  const ExportToProduction = async () => {
    setLoading(true);

    try {
      let arr = dataProduction?.data.map((item , index) => {
        const newData = {
          ลำดับ: index + 1,
          รหัสสินค้า: item,
          ชื่อสินค้า: item.product_name,
          รายละเอียดสินค้า: item.sku_description,
          จำนวน: numberFormat(item.qty),
          ขายต่อหน่วยรวมภาษี: numberFormat(item.price),
          รวมขายรวมภาษี: numberFormat(item.total_price),
        };

        return newData;
      });
      if (arr) {
        let Heading = [
          [
            "ลำดับ",
            "รหัสสินค้า",
            "ชื่อสินค้า",
            "รายละเอียดสินค้า",
            "จำนวน",
            "ขายต่อหน่วยรวมภาษี",
            "รวมขายรวมภาษี"
          ],
        ];

        const tableName = `ส่งผลิตProduction`;
        const exportDate = `Export Date: ${moment(new Date()).format("DD-MM-YYYY")}`;
        const exportName =  `User: ${usrName}`;

        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, [[tableName]], { origin: "A1" });
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
        
        XLSX.utils.sheet_add_aoa(ws, [[exportName]], { origin: "A2" });
        XLSX.utils.sheet_add_aoa(ws, [[exportDate]], { origin: "A3" });
        XLSX.utils.sheet_add_aoa(ws, Heading,  { origin: "A5" });
        XLSX.utils.sheet_add_json(ws, arr, { origin: "A6", skipHeader: true });

        ws["A1"].s = {
          font: { bold: true, underline: true },
          alignment: { horizontal: "center", vertical: "center" }
        };

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, genfileName());
      } else {
        message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
        setLoading(false);
        return;
      }
    } catch (error) {
      message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const genfileName = () => {
    const date = new Date();
    const fileName = `export_send_production_${moment(date).format(
      "DD-MM-YYYY-HHMMSS"
    )}.xlsx`;
    return fileName;
  };

  return (
    <Button
      type="default"
      style={{ marginRight: 10 }}
      icon={<DownloadOutlined />}
      size="middle"
      loading={loading}
      onClick={ExportToProduction}
    >
      ส่งผลิต Production
    </Button>
  );
};

export default ExportToProduction;
